///Get the container for no results and remove the after effect
let listingContainer = document.querySelector('.has-after')
if(listingContainer){
  //console.log(listingContainer)
  let templateBackground = listingContainer.querySelector('.no-results_container')
  if (templateBackground){
    //console.log(templateBackground.parentElement.parentElement)
    templateBackground.parentElement.parentElement.classList.add('after-removed')
  }
}



// WEBPACK FOOTER //
// ./CMS/NationalGuild/src/js/components/no-results.js